const INITIALS_PALETTE = [
  '#1976d2', // blue
  '#2e7d32', // green
  '#7b1fa2', // purple
  '#ed6c02', // orange
  '#00838f', // teal
  '#5e35b1', // deep purple
  '#c62828', // red
  '#455a64', // blue grey
];

export function getInitials(name: string): string {
  if (!name || !name.trim()) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase().slice(0, 2);
  }
  if (parts[0].length >= 2) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return parts[0][0].toUpperCase();
}

export function getColorForName(name: string): string {
  if (!name || !name.trim()) return INITIALS_PALETTE[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = ((hash << 5) - hash) + name.charCodeAt(i);
    hash |= 0;
  }
  const index = Math.abs(hash) % INITIALS_PALETTE.length;
  return INITIALS_PALETTE[index];
}
